import React, {ChangeEvent, FormEvent, ReactElement, useState} from "react";
import {useQueryParams} from "../hooks/useQueryParams";
import axios from "axios";
import {message} from "antd";
import {useIntl} from "react-intl";

export type WechatBindFormPropsType = {
    username: string
    changeUsername: (e: ChangeEvent<HTMLInputElement>) => void
    mailCode: string
    changeMailCode: (e: ChangeEvent<HTMLInputElement>) => void
    bindLoading: boolean
    onSendMailCode: (load: () => void, resovle: () => void, reject: () => void) => void
}

export function withWechatBindForm(WrappedComponent: React.FC<WechatBindFormPropsType>) {
    return () => {
        let intl = useIntl();
        const [username, setUsername] = useState('');
        const [mailCode, setMailCode] = useState('');
        const [bindLoading, setBindLoading] = useState(false);
        const queryParams = useQueryParams<{token: string}>();

        const onSendMailCode = (load: () => void, resovle: () => void, reject: () => void) => {
            if (!username) {
                resovle()
                return message.error(intl.formatMessage({id: '邮箱不能为空'}))
            }
            load()
            axios.create().post(`${process.env.REACT_APP_ACCOUNT_URL}api/oauth2/sendMailCode.htm`, {
                mail: username,
                token: queryParams!.token
            }).then(data => {
                if (data.data.status === '0') {
                    message.success(intl.formatMessage({id: '发送成功'}));
                    resovle()
                    return;
                }
                reject()
                message.error(data.data.desc);
            });
        }

        const onBind = (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault()
            if (!username) {
                return message.error(intl.formatMessage({id: '邮箱不能为空'}))
            }
            if (!mailCode) {
                return message.error(intl.formatMessage({id: '验证码不能为空'}))
            }
            setBindLoading(true)
            axios.create().post(`${process.env.REACT_APP_ACCOUNT_URL}api/oauth2/wechat/bind.htm`, {
                mail: username,
                code: mailCode,
                token: queryParams!.token
            }).then(data => {
                setBindLoading(false)
                if (data.data.status === '0') {
                    window.top.location.href = data.data.data;
                    return;
                }
                message.error(data.data.desc);
            });
        }
        const inputChangeHandler = (handler: (v: string) => void) => {
            return (e: ChangeEvent<HTMLInputElement>) => {
                handler(e.target.value)
            }
        }
        return (
            <form className={'form'} onSubmit={onBind}>
                <WrappedComponent
                    username={username}
                    changeUsername={inputChangeHandler(setUsername)}
                    mailCode={mailCode}
                    changeMailCode={inputChangeHandler(setMailCode)}
                    onSendMailCode={onSendMailCode}
                    bindLoading={bindLoading}
                />
            </form>
        )
    }
}
